import { columnHelper } from './helper';

export const name = columnHelper.accessor('name', {
  header: 'Name',
  id: 'name',
});
